import { supabase } from './supabaseClient';

const KEYS_URL = '/.netlify/functions/account-api-keys';

async function authHeader() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Sign in to manage API keys');
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

async function parse(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  return body;
}

export async function listAccountApiKeys() {
  const headers = await authHeader();
  const res = await fetch(KEYS_URL, { headers });
  return parse(res);
}

export async function createAccountApiKey({ name, expires_in_days } = {}) {
  const headers = await authHeader();
  const res = await fetch(KEYS_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ name, expires_in_days }),
  });
  return parse(res);
}

export async function revokeAccountApiKey(keyId) {
  const headers = await authHeader();
  const res = await fetch(KEYS_URL, {
    method: 'DELETE',
    headers,
    body: JSON.stringify({ key_id: keyId }),
  });
  return parse(res);
}
